import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {SessionService, ConfigService, User} from '@q9elements/ui-kit/common';
import {get} from 'lodash';
import {catchError, map, throwError} from 'rxjs';

import {Q9maCookieService} from '../services/cookie.service';

@Injectable()
export class SpaceInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private sessionService: SessionService,
    private cookieService: Q9maCookieService
  ) {}

  intercept(req: HttpRequest<User>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError(error => {
        if (req.url !== `${ConfigService.environment.API_ENDPOINT}/account`) {
          return throwError(() => error);
        }

        const shouldLoadUser = ['organization.not_found', 'user_in_team.blocked'].includes(
          error.error.status
        );

        if (!shouldLoadUser) {
          return throwError(() => error);
        }

        const request = req.clone({url: `${ConfigService.environment.API_ENDPOINT}/admin/account`});

        return next.handle(request).pipe(
          map((event: HttpEvent<User>) => {
            if (event.type === HttpEventType.Response) {
              const teams = get(event.body, 'teams', []);
              const defaultTeam = teams.find(team => team.defaultTeam);

              return event.clone({
                body: {
                  ...event.body,
                  userInTeam: defaultTeam
                }
              });
            }

            return event;
          })
        );
      })
    );
  }
}

export function provideSpaceInterceptor() {
  return {
    provide: HTTP_INTERCEPTORS,
    useClass: SpaceInterceptor,
    multi: true
  };
}
